import { CartLine } from 'shopify-buy';
import { debounce, sha1 } from '../../../utils/utils';

// We proxy requests through our own API instead of using the Iterable recommended JWT flow directly.
// The JWT approach creates security risks: if leaked, an attacker could use the API key and JWT
// to impersonate customers and modify their data in Iterable. Since we can’t reliably distinguish
// between legitimate frontend requests and malicious ones, we avoid exposing that flow.
const API_ENDPOINT = 'https://embarkvet.com/wp-json/embark/v1/cart';

interface DigiohFormData {
  submittedEmail?: string;
  submittedFirstName?: string;
  submittedLastName?: string;

  [key: string]: any;
}

function getCustomerData(): DigiohFormData | null {
  const digioh_form_data = window.document.cookie
    .split('; ')
    .find((row) => row.startsWith('digioh_form_data='));
  if (digioh_form_data) {
    const cookieValue = atob(digioh_form_data.split('=')[1]);
    try {
      return JSON.parse(cookieValue);
    } catch (error) {
      return null;
    }
  }

  if (window.heap && window.heap.identity) {
    return { submittedEmail: window.heap.identity, heap: 'true' };
  }

  return null;
}

export const syncCartWithIterable = () => {
  const handleCartUpdatedEvent = debounce(async function (event) {
    const cart = (event as CustomEvent).detail.cart;
    const items = cart.lines.edges.map((edge: { node: CartLine }) => {
      const line = edge.node;
      return {
        id: line.merchandise.id,
        name: line.merchandise.product.title,
        price: parseFloat(`${line.cost.subtotalAmount.amount}`),
        quantity: line.quantity,
        sku: line.merchandise.sku,
        lineId: line.id,
      };
    });

    const customerData = getCustomerData();
    if (!customerData?.submittedEmail) {
      return;
    }

    const email = customerData.submittedEmail;

    if (JSON.stringify(items) === localStorage.getItem('iterable_cart_items')) {
      return;
    }

    localStorage.setItem('iterable_cart_items', JSON.stringify(items));

    fetch(API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Token': `${await sha1(email)}`,
      },
      body: JSON.stringify({ items, email }),
    })
      // eslint-disable-next-line no-console
      .catch(console.log);
  }, 3000);

  document.addEventListener('cart:updated', handleCartUpdatedEvent);
};
